export default __webpack_public_path__ + "static/bg_grain-57adf15f8b80dbfe22a2a7352a452e08.jpg";